(() => {
  if (window.TexanPurchaseClarityReady) return;
  window.TexanPurchaseClarityReady = true;
  const money = (value, currency) => new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency, maximumFractionDigits: value % 100 ? 2 : 0 }).format(value / 100);
  const localZips = new Set(['77301','77302','77303','77304','77306','77316','77320','77340','77354','77355','77356','77357','77365','77373','77375','77377','77379','77380','77381','77382','77384','77385','77386','77388','77389']);
  function deliveryCheck(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const input = root.querySelector('[data-tx-purchase-zip]');
    const result = root.querySelector('[data-tx-purchase-delivery-result]');
    const run = () => {
      const zip = input.value.replace(/\D/g, '').slice(0, 5);
      input.value = zip; result.hidden = false;
      result.textContent = zip.length === 5 ? (localZips.has(zip) ? root.dataset.localCopy : root.dataset.nationalCopy) : root.dataset.invalid;
    };
    root.querySelector('[data-tx-purchase-zip-check]').addEventListener('click', run);
    input.addEventListener('keydown', event => { if (event.key === 'Enter') { event.preventDefault(); event.stopPropagation(); run(); } });
  }
  function init(dataNode) {
    if (dataNode.dataset.ready) return;
    let data;
    try { data = JSON.parse(dataNode.textContent); } catch { return; }
    const featured = dataNode.closest('[data-product-featured]');
    const info = featured?.querySelector('.t4s-product__info-container');
    const form = info?.querySelector('form[data-type="add-to-cart-form"]');
    if (!form) return;
    if (data.handle === 'the-winkbed') {
      const buyButtons = form.querySelector('.t4s-product-form__buttons');
      const optionalBase = form.querySelector('[data-tx-sleep-system]');
      const optionalBasePanel = optionalBase?.closest('details') || optionalBase;
      if (buyButtons && optionalBasePanel && (buyButtons.compareDocumentPosition(optionalBasePanel) & Node.DOCUMENT_POSITION_PRECEDING)) {
        optionalBasePanel.insertAdjacentElement('beforebegin', buyButtons);
      }
    }
    dataNode.dataset.ready = 'true';
    let queued = false;
    const currentVariant = () => data.variants.find(variant => String(variant.id) === String(form.querySelector('[name="id"]')?.value));
    const setText = (selector, text) => document.querySelectorAll(selector).forEach(node => { if (node.textContent !== text) node.textContent = text; });
    function update() {
      queued = false;
      const variant = currentVariant();
      if (!variant) return;
      info.querySelectorAll('[data-tx-inline-fit]').forEach(node => {
        const index = Number(node.dataset.optionIndex);
        const copy = data.fitChoices?.[index]?.[variant.options[index]];
        if (copy && node.textContent !== copy) node.textContent = copy;
      });
      const coverIndex = data.options.findIndex(name => /cool|cover|fabric/.test(String(name).toLowerCase()));
      if (coverIndex >= 0) {
        const value = variant.options[coverIndex];
        const lower = String(value).toLowerCase();
        const label = /no thanks/.test(lower) ? data.text.standard : /tencel/.test(lower) ? data.text.tencel : /coolforce/.test(lower) ? data.text.coolforce : /glaciotex/.test(lower) ? data.text.glaciotex : /frost/.test(lower) ? data.text.frost : value;
        setText('[data-tx-cooling-label]', label);
      }
      const feel = variant.options.map(option => {
        if (data.feels[option]) return option;
        if (data.handle === 'the-winkbed' && /^Luxury Firm/.test(option)) return 'Luxury Firm';
        if (data.handle === 'the-winkbed' && /^Plus/.test(option)) return 'Plus';
        return null;
      }).find(option => option && data.feels[option]);
      const guidance = data.feels[feel];
      if (guidance) {
        for (const field of ['label', 'best', 'avoid', 'positions', 'note']) setText('[data-tx-feel-' + field + ']', guidance[field]);
        setText('[data-tx-feel-answer]', guidance.label + '. ' + guidance.best);
        setText('[data-tx-feel-support]', data.text.support + ' ' + guidance.label + '. ' + guidance.positions + '.');
      }
      const bundle = form.querySelector('[data-tx-sleep-system]');
      const selectedBundle = bundle?.querySelector('[data-tx-tier] input:checked, input[value="bundle"]:checked');
      const unitTotal = selectedBundle ? Number(bundle.dataset.txSystemPrice || variant.price) : variant.price;
      const quantity = Math.max(1, Math.floor(Number(form.querySelector('[name="quantity"]')?.value) || 1));
      const accessoryPrice = window.TexanSleepEssentials?.price(form) || 0;
      const total = (unitTotal + accessoryPrice) * quantity;
      info.querySelectorAll('[data-tx-selected-accessories]').forEach(node => {
        node.hidden = accessoryPrice === 0;
        node.textContent = accessoryPrice ? data.text.accessoriesAdded + ' ' + money(accessoryPrice * quantity, data.currency) : '';
      });
      info.querySelectorAll('[data-tx-selected-quantity]').forEach(node => {
        node.hidden = quantity === 1;
        node.textContent = data.text.quantity.replace('[count]', String(quantity));
      });
      const selectedChoice = selectedBundle?.closest('[data-tx-tier]');
      info.querySelectorAll('[data-tx-selected-base]').forEach(node => {
        node.hidden = !selectedChoice;
        node.textContent = selectedChoice ? data.text.baseAdded.replace('[model]', selectedChoice.dataset.tierLabel + ' · ' + selectedChoice.dataset.model) : '';
      });
      const savings = Math.max(0, Number(variant.compareAt || 0) - Number(variant.price));
      info.querySelectorAll('[data-tx-variant-savings]').forEach(node => {
        node.hidden = savings <= 0;
        const value = node.querySelector('[data-tx-save-value]');
        if (value) value.textContent = data.text.save.replace('[amount]', money(savings, data.currency));
      });
      if (guidance) {
        const numeric = String(guidance.label).match(/(\d+(?:\.\d+)?)\s*\/\s*10/);
        info.querySelectorAll('[data-tx-comfort-scale]').forEach(scale => {
          const value = numeric ? Number(numeric[1]) : 0;
          scale.hidden = value <= 0 || value > 10;
          scale.style.setProperty('--tx-feel-position', Math.max(0, Math.min(100, value * 10)) + '%');
        });
      }
      const summary = info.querySelector('[data-tx-purchase-total]');
      if (summary) { summary.hidden = !selectedBundle; summary.textContent = data.text.system + ' ' + money(total, data.currency); }
      info.querySelectorAll('[data-tx-monthly]').forEach(node => { node.textContent = money(total / 48, data.currency); });
      info.querySelectorAll('[data-tx-selected-price]').forEach(node => { node.textContent = money(total, data.currency); });
      info.querySelectorAll('[data-tx-selected-title]').forEach(node => { node.textContent = variant.title; });
      info.querySelectorAll('[data-tx-builder-link]').forEach(node => { const url = new URL(node.href); url.searchParams.set('variant', variant.id); node.href = url.href; });
      document.querySelectorAll('[data-tx-conversion-suite]').forEach(node => { node.dataset.currentVariant = variant.title; });
      form.querySelectorAll('[data-swatch-option]').forEach(group => {
        const index = Number(group.dataset.id);
        if (!Number.isInteger(index)) return;
        const name = String(data.options[index] || '').toLowerCase();
        if (!/cool|cover|frost|fabric/.test(name)) return;
        const matches = data.variants.filter(candidate => candidate.options.every((option, i) => i === index || option === variant.options[i]));
        if (!matches.length) return;
        const baseline = Math.min(...matches.map(candidate => candidate.price));
        group.querySelectorAll('[data-swatch-item]').forEach(button => {
          const value = button.dataset.value;
          const candidate = matches.find(item => item.options[index] === value);
          if (!candidate) return;
          const lower = String(value).toLowerCase();
          let label = value;
          if (data.handle === 'the-winkbed') label = /no thanks|tencel/.test(lower) ? data.text.tencel : data.text.frost;
          else if (/tencel/.test(lower)) label = data.text.tencel;
          else if (/coolforce/.test(lower)) label = data.text.coolforce;
          else if (/glaciotex/.test(lower)) label = data.text.glaciotex;
          let labelNode = button.querySelector('[data-tx-upgrade-label]');
          if (!labelNode) {
            labelNode = document.createElement('span'); labelNode.dataset.txUpgradeLabel = '';
            const priceNode = document.createElement('small'); priceNode.dataset.txUpgradePrice = '';
            button.replaceChildren(labelNode, priceNode);
          }
          const delta = candidate.price - baseline;
          const priceText = delta === 0 ? data.text.included : '+' + money(delta, data.currency);
          labelNode.textContent = label;
          button.querySelector('[data-tx-upgrade-price]').textContent = priceText;
          button.setAttribute('aria-label', label + ' — ' + priceText + (candidate.available ? '' : ' — ' + data.text.unavailable));
        });
      });
    }
    const queue = () => { if (!queued) { queued = true; requestAnimationFrame(update); } };
    form.addEventListener('change', queue);
    form.addEventListener('tx:essentials-change', queue);
    new MutationObserver(queue).observe(form, { subtree: true, attributes: true, attributeFilter: ['class', 'selected', 'value', 'data-tx-system-price'] });
    update();
  }
  function purchaseExtras(featured) {
    const info = featured.querySelector('.tx-mobile-product');
    const proof = info?.querySelector('.tx-cro-reviews');
    const reviewTarget = document.getElementById('judgeme_product_reviews') || document.getElementById(proof?.dataset.txReviewFallback || '');
    if (proof && reviewTarget?.id) { proof.href = '#' + reviewTarget.id; proof.dataset.goId = '#' + reviewTarget.id; }
    const plans = info?.querySelector('[data-tx-finance-plans]');
    if (plans) info.querySelectorAll('[data-tx-finance-alternate]').forEach(node => { if (node.parentElement !== plans) plans.appendChild(node); node.hidden = false; });
    const nav = featured.querySelector('[data-tx-photo-nav]');
    const gallery = featured.querySelector('[data-main-media]');
    if (!nav || !gallery || nav.dataset.ready) return;
    nav.dataset.ready = 'true';
    const buttons = [...nav.querySelectorAll('[data-tx-photo-id]')];
    const slides = () => [...gallery.querySelectorAll('[data-main-slide]:not(.is--media-hide)')];
    const sync = () => {
      const selected = gallery.querySelector('[data-main-slide].is-selected')?.dataset.mediaId;
      buttons.forEach(button => { const value = String(button.dataset.txPhotoId === selected); if (button.getAttribute('aria-pressed') !== value) button.setAttribute('aria-pressed',value); });
    };
    nav.addEventListener('click',event => {
      const button = event.target.closest('[data-tx-photo-id]');
      if (!button) return;
      const items = slides();
      const current = items.findIndex(slide => slide.classList.contains('is-selected'));
      const target = items.findIndex(slide => slide.dataset.mediaId === button.dataset.txPhotoId);
      if (current < 0 || target < 0) return;
      const delta = target - current;
      const arrow = gallery.querySelector(delta < 0 ? '.flickityt4s-prev-next-button.previous' : '.flickityt4s-prev-next-button.next');
      for (let step = 0; step < Math.abs(delta); step++) arrow?.click();
      sync();
    });
    new MutationObserver(sync).observe(gallery,{subtree:true,attributes:true,attributeFilter:['class']});
    sync();
  }
  const boot = scope => {
    (scope || document).querySelectorAll('[data-tx-purchase-data]').forEach(init);
    (scope || document).querySelectorAll('[data-tx-delivery-check]').forEach(deliveryCheck);
    (scope || document).querySelectorAll('[data-product-featured]').forEach(purchaseExtras);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot(document)); else boot(document);
  document.addEventListener('shopify:section:load', event => boot(event.target));
})();

